<template>
	<div class="main">
		<FormWrapper :action="formAction" :method="formMethod">
			<div class="title-bar">
				<h1 class="mb-0">{{ !!document.id ? "Edit" : "Add New" }} Tech Doc</h1>
				<a class="btn-back" :href="route('admin.documents.index')">
					<span class="icon icon-arrow-left"></span>
					<span class="text">Back to List</span>
				</a>
			</div>
			<div class="row no-gutters py-4">
				<div class="col-12 col-lg-8 col-xl-9">
					<div class="row no-gutters px-3 pl-lg-4 pr-lg-0 pl-xl-5">
						<div class="col-12">
							<transition name="fade">
								<Alert v-if="hasAlert" :alert="alert"/>
							</transition>
						</div>
						<div class="col-12 col-md-6 mb-3 pr-md-2">
							<Field
								type="text"
								name="title"
								label="Title"
								:value="document.title"
								validate="required"
							/>
						</div>
						<div class="col-12 col-md-6 mb-3 pl-md-2">
							<Field type="text" name="subtitle" label="Subtitle" :value="document.subtitle"/>
						</div>
						<div class="col-12 mb-3">
							<Field
								type="text"
								name="module_path"
								label="Launch File"
								:value="document.module_path"
								validate="required"
								validate-as="Launch File"
							/>
						</div>
						<div class="col-12 col-md-6 mb-3 pr-md-2">
							<MultiAssignField
								type="select"
								label="Brand"
								name="brands"
								:options="brands"
								v-model="brand_ids"
							/>
						</div>
						<div class="col-12 col-md-6 mb-3 pr-md-2">
							<MultiAssignField
								type="select"
								label="Brand Navigation Hidden"
								name="hide_from_nav"
								:options="brands"
								v-model="hidden_brand_ids"
							/>
						</div>
						<!--            <div class="d-none d-md-block col-md-6"></div>-->
						<div class="col-12 mb-5">
							<AssetField
								name="image_id"
								label="Featured Image"
								:value="document.image_id"
								:types="['image']"
							/>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
					<div class="sticky-top">
						<div class="row no-gutters text-center">
							<div class="col-12 pb-3">
								<button type="submit" class="btn btn-success w-50">Save Changes</button>
							</div>
							<div class="col-12 pb-3">
								<a :href="route('admin.documents.index')" class="btn btn-danger w-50">Cancel & Exit</a>
							</div>
							<template v-if="!!document.id">
								<div class="col-12 font-size-sm text-center pt-4">
									<span>Last updated on {{ document.updated_at | moment("MM/DD/YYYY") }}</span>
									<span>at {{ document.updated_at | moment("h:mma") }}</span>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</FormWrapper>
	</div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";

export default {
	mixins: [DisplaysAlerts],
	props: {
		document: {type: Object, required: true},
		brands: {type: Array, default: () => []},
	},
	data() {
		return {
			brand_ids: [],
		};
	},
	computed: {
		routeParam() {
			return {document: this.document.id || null};
		},
		formAction() {
			return !this.document.id
				? this.route("admin.documents.store")
				: this.route("admin.documents.update", this.routeParam);
		},
		formMethod() {
			return !this.document.id ? "POST" : "PUT";
		},
	},
	mounted() {
		this.brand_ids = this.document.brand_ids || [];
		this.hidden_brand_ids = this.document.hidden_brand_ids || [];
	},
};
</script>